/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Province_LabelInputs */

const vi_customer_province_label = /** @type {(inputs: Customer_Province_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tỉnh / Thành phố`)
};

/**

* @param {Customer_Province_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_province_label = /** @type {((inputs?: Customer_Province_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Province_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_province_label(inputs)
});